import { ReactNode } from 'react'
import { useTranslation } from 'next-i18next/pages'
import EmptyFolderIcon from 'shared/icons/empty-folder-icon'

const NotificationEmptyList = (): ReactNode => {
  const { t } = useTranslation()
  return (
    <div className="flex w-full flex-col items-center justify-center gap-3 rounded-b-lg bg-bg-primary py-20">
      <EmptyFolderIcon height={100} width={100} />
      <div className={`flex flex-col items-center`}>
        <span className={'text-base font-medium text-text-primary'}>
          {t('profile.notifications.empty_list.title')}
        </span>
        <span className={'text-base text-text-primary'}>
          {t('profile.notifications.empty_list.description')}
        </span>
      </div>
    </div>
  )
}

export default NotificationEmptyList
